export function toSnakeCaseKeys(originalObj) {
  if (typeof originalObj !== 'object') {
    return originalObj;
  }

  return Object.keys(originalObj || {}).reduce((newObject, key) => {
    const newKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    const originalVal = originalObj[key];
    let newValue = originalVal;
    if (!originalVal) {
      newValue = originalVal;
    } else if (Array.isArray(originalVal)) {
      newValue = originalVal.map(toSnakeCaseKeys);
    } else if (typeof originalVal === 'object') {
      newValue = toSnakeCaseKeys(originalVal);
    }
    return key === '__typename'
      ? newObject
      : {
          ...newObject,
          [newKey]: newValue,
        };
  }, {});
}
